/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BasketsValidatePost200ResponseCoupon from './BasketsValidatePost200ResponseCoupon';

/**
 * The BasketsValidatePost200Response model module.
 * @module model/BasketsValidatePost200Response
 * @version 1.0.0
 */
class BasketsValidatePost200Response {
    /**
     * Constructs a new <code>BasketsValidatePost200Response</code>.
     * @alias module:model/BasketsValidatePost200Response
     */
    constructor() { 
        
        BasketsValidatePost200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsValidatePost200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsValidatePost200Response} obj Optional instance to populate.
     * @return {module:model/BasketsValidatePost200Response} The populated <code>BasketsValidatePost200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsValidatePost200Response();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('coupon')) {
                obj['coupon'] = BasketsValidatePost200ResponseCoupon.constructFromObject(data['coupon']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsValidatePost200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsValidatePost200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        // validate the optional field `coupon`
        if (data['coupon']) { // data not null
          BasketsValidatePost200ResponseCoupon.validateJSON(data['coupon']);
        }

        return true;
    }


}



/**
 * @member {String} message
 */
BasketsValidatePost200Response.prototype['message'] = undefined;

/**
 * @member {module:model/BasketsValidatePost200ResponseCoupon} coupon
 */
BasketsValidatePost200Response.prototype['coupon'] = undefined;






export default BasketsValidatePost200Response;

